// Catalog of events that can fire emails, and who can receive them.
// Shared by the dispatch engine (functions) and the Email admin UI (src).

export interface EmailEvent {
  key: string;
  label: string;
  description: string;
  vars: string[]; // template variables available for this event
}

export const EMAIL_EVENTS: EmailEvent[] = [
  { key: 'staff.created', label: 'Staff member added', description: 'An admin adds a new staff or contractor profile.', vars: ['name', 'role', 'type', 'email', 'org_name'] },
  { key: 'onboarding.started', label: 'Onboarding started', description: 'A person is enrolled into onboarding.', vars: ['name', 'role', 'start_date', 'org_name'] },
  { key: 'onboarding.step_completed', label: 'Onboarding step completed', description: 'A single onboarding task is checked off.', vars: ['name', 'step', 'system', 'org_name'] },
  { key: 'onboarding.completed', label: 'Onboarding finished', description: 'All onboarding tasks are done.', vars: ['name', 'role', 'org_name'] },
  { key: 'offboarding.started', label: 'Offboarding started', description: 'A person is enrolled into offboarding.', vars: ['name', 'role', 'org_name'] },
  { key: 'offboarding.completed', label: 'Offboarding finished', description: 'All offboarding tasks are done.', vars: ['name', 'org_name'] },
  { key: 'invoice.submitted', label: 'Invoice submitted', description: 'A contractor submits an invoice.', vars: ['name', 'invoice_num', 'amount', 'project', 'org_name'] },
  { key: 'invoice.approved', label: 'Invoice approved', description: 'An invoice is approved.', vars: ['name', 'invoice_num', 'amount', 'org_name'] },
  { key: 'client.created', label: 'Client added', description: 'A new client organization is created.', vars: ['client_name', 'industry', 'org_name'] },
  { key: 'admin.invited', label: 'Admin invited', description: 'A new admin/manager is invited.', vars: ['email', 'role', 'org_name'] },
  { key: 'assignment.created', label: 'Staff assigned to a location', description: 'An admin assigns a staff member to a client location/project.', vars: ['name', 'client_company', 'location', 'project', 'start_date', 'org_name'] },
];

export interface RecipientOption {
  key: string;
  label: string;
}

export const RECIPIENT_OPTIONS: RecipientOption[] = [
  { key: 'subject', label: 'The person (event subject)' },
  { key: 'actor', label: 'The acting user (e.g. assigning admin)' },
  { key: 'admins', label: 'All admins' },
  { key: 'managers', label: 'All managers' },
  { key: 'admins_managers', label: 'Admins & managers' },
  { key: 'custom', label: 'Specific address' },
];

export const eventLabel = (key: string) => EMAIL_EVENTS.find((e) => e.key === key)?.label || key;
export const recipientLabel = (key: string) => RECIPIENT_OPTIONS.find((r) => r.key === key)?.label || key;
